export default __webpack_public_path__ + "file-asset/90192f14938038e9be93f43e7706537f-phone.svg";